export class Node {
  name: string;
  label: string;
  type: string;
  extension: string;
  children: Node[];
  path: string;
  expanded: boolean;
  content: string;
  special: boolean;
  url: string;
  sha: string;
  committers: any[];
  blames: any[];
  visible?: boolean;
  newName: string;
  get checkIfNodeIsMedia() {
    return Node.checkIfNodeIsMedia(this.path);
  }
  static checkIfNodeIsMedia(path: string) {
    const mediaExtensions = ["png", "jpg", "jpeg", "gif", "svg", "webp", "mp4", "webm", "ogg", "mp3", "wav"];
    const extension = path.split(".").pop();
    return mediaExtensions.includes(extension);
  }
  get isMarkdown() {
    const name = this.path;
    return name?.endsWith(".md") || name?.endsWith(".mdx");
  }
  get mediaType() {
    const extension = this.path.split(".").pop();
    if (extension === "mp4") {
      return "video/mp4";
    } else if (extension === "webm") {
      return "video/webm";
    } else if (extension === "ogg") {
      return "video/ogg";
    } else if (extension === "mp3") {
      return "audio/mp3";
    } else if (extension === "wav") {
      return "audio/wav";
    } else if (extension === "svg") {
      return "image/svg+xml";
    } else {
      return "image/" + extension;
    }
  }
  get language() {
    const extension = this.path.split(".").pop();
    if (extension === "js") {
      return "javascript";
    } else if (extension === "ts") {
      return "typescript";
    } else if (extension === "scss") {
      return "sass";
    } else if (extension === "mdx") {
      return "markdown";
    } else if (extension === "yml") {
      return "yaml";
    } else if (extension === "sh") {
      return "bash";
    } else if (extension === "rb") {
      return "ruby";
    } else if (extension === "rs") {
      return "rust";
    } else if (extension === "py") {
      return "python";
    } else if (extension === "sql") {
      return "sql";
    } else if (extension === 'kt') {
      return 'kotlin';
    } else if (extension === 'css') {
      return 'css';
    } else if (extension === 'mat') {
      return 'matlab';
    } else {
      return extension;
    }

  }
}
